<template>
  <div v-if="path != '/vr'" class="navbar-container">
    <div class="nav-left">
      <img
        src="../../assets/img/logo_color.png"
        alt=""
        class="regular"
      />
    </div>
    <div v-if="screenWidth >= 1024">
      <Navbar mode="horizontal"/>
    </div>
     <div class="nav-position" v-show="selected">
      <Navbar mode="vertical" @hiddenHandle="showMenuClick"/>
    </div>

    <div v-if="screenWidth < 1024" class="nav-right" @click="showMenuClick">
      <i class="el-icon-more" style="font-size: 20px;"></i>
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/navBar/index.vue";

export default {
  components: {
    Navbar,
  },
  name: "NewHeader",
  data() {
    return {
      path: this.$route.path,
      selected: false,
      screenWidth: "",
      showMenu: {
        isShow: false,
        isOpenStatus: 0,
      },
    };
  },

  mounted() {
    this.screenWidth = document.body.clientWidth;
    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth;
        this.$nextTick(() => {
          this.screenWidth = document.body.clientWidth;
        });
      })();
    };
  },
  methods: {
    jump() {
      window.open("/vr");
    },
    showMenuClick() {
      this.selected = !this.selected
    },
  },
};
</script>
<style scoped lang="less">
/deep/.el-menu {
  border-bottom: none !important;
  .el-menu-item {
    font-size: 16px;
    padding: 0 10px;
    font-weight: 500;
    color: #666666;
    &:hover {
      background-color: #f5f5f5;
    }
  }
  .el-submenu__title {
    font-size: 16px;
    padding: 0 10px;
    font-weight: 500;
    color: #666666;
  }
}

/deep/ .el-menu--horizontal > .el-submenu .el-submenu__title {
  border-bottom: 2px solid transparent;
  color: #666666;
}

.navbar-container {
  display: flex;
  background-color: #f5f5f5;
  position: relative;
  align-items: center;
  padding: 20px 0;

  .nav-left {
    margin-right: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 10px;
  }
  .nav-position {
    position: absolute;
    z-index: 100;
    top: 40px;
    left: 0;
    right: 0;
  }
  .nav-right {
    position: absolute;
    right: 10px;
    padding: 5px 10px;
  }
}
/*自定义显示缩小菜单*/

.customShowMenu {
  display: block;
  background-color: #ffffff;
  z-index: 99;
}

/* .customnoneMenu {
  display: none;
} */
@media screen and (max-width: 1024px) {
  .navbar-container {
    height: 60px;
    line-height: 60px;
  }
  .con nav > ul > li > h2 a {
    text-align: left;
    width: 100%;
  }
}
</style>
